var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pt-1 d-none d-md-flex",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pb-0"},[_c('v-img',{attrs:{"contain":"","height":"150px","src":require('@/assets/logo_name.png')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }